import { ReactNode } from 'react';
import { useOnboardingDocuments } from '../../../../customhooks/useOnboardingDocuments';
import { useUserProfile } from '../../../../customhooks/useUserProfile';
import { DocumentRejected } from './DocumentRejected';
import { DocumentReview } from './DocumentReview';
import { RcNumberRejected } from './RcNumberRejected';
import { RcNumberReview } from './RCNumberReview';
import { UploadDocuments } from './UploadDocuments';

export const ReviewDocuments = () => {
    const { userDetails, refetch: refetchUser } = useUserProfile();

    const { onboardingDocuments, refetch: refetchOnbordingDocuments } =
        useOnboardingDocuments({
            corporateId: userDetails?.corporate?.id,
            status: userDetails?.corporate?.status
        });

    const statusView: { [key: number]: ReactNode } = {
        2: <RcNumberReview userDetails={userDetails} />,
        3: (
            <UploadDocuments
                {...{
                    onboardingDocuments,
                    refetchOnbordingDocuments,
                    refetchUser
                }}
            />
        ),
        4: <DocumentReview userDetails={userDetails} />,
        5: (
            <DocumentRejected
                {...{ onboardingDocuments, userDetails, refetchUser }}
            />
        ),
        6: <RcNumberRejected />
    };

    return (
        <>
            {userDetails?.corporate?.status &&
            userDetails?.documents?.length &&
            userDetails?.documents?.some((item) => item.status === 0)
                ? statusView[5]
                : statusView[userDetails?.corporate?.status]}
        </>
    );
};
